import { render, staticRenderFns } from "./CompanyWKR.vue?vue&type=template&id=37936ea3&"
import script from "./CompanyWKR.vue?vue&type=script&lang=js&"
export * from "./CompanyWKR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports